export type AppointmentStatusTone = 'success' | 'info' | 'warning' | 'danger' | 'neutral'

export type AppointmentStatusPresentation = {
  key: string
  label: string
  tone: AppointmentStatusTone
}

const STATUS_REGISTRY: Array<{ match: RegExp; key: string; label: string; tone: AppointmentStatusTone }> = [
  { match: /^(finished|completed|done|closed|окончен|заверш)/i, key: 'finished', label: 'Окончен', tone: 'success' },
  { match: /^(confirmed|confirm|подтверж)/i, key: 'confirmed', label: 'Подтверждён', tone: 'info' },
  { match: /^(upcoming|scheduled|planned|pending|предстоит|заплан)/i, key: 'upcoming', label: 'Предстоит', tone: 'info' },
  { match: /^(in_progress|in-progress|started|идет|прием)/i, key: 'in_progress', label: 'Идёт приём', tone: 'warning' },
  { match: /^(cancel|отмен)/i, key: 'cancelled', label: 'Отменён', tone: 'danger' },
  { match: /^(no_show|noshow|неяв|не яв)/i, key: 'no_show', label: 'Не явился', tone: 'danger' },
  { match: /^(waiting|ожид)/i, key: 'waiting', label: 'Ожидает', tone: 'warning' },
]

export function resolveAppointmentStatusPresentation(
  status: string | null | undefined,
  statusLabel?: string | null,
): AppointmentStatusPresentation {
  const raw = (statusLabel ?? status ?? '').trim()
  if (!raw) {
    return { key: 'unknown', label: 'Без статуса', tone: 'neutral' }
  }

  for (const entry of STATUS_REGISTRY) {
    if (entry.match.test(raw)) {
      return { key: entry.key, label: entry.label, tone: entry.tone }
    }
  }

  return { key: raw.toLowerCase(), label: raw, tone: 'neutral' }
}

export function summarizeTodayAppointments(
  appointments: Array<{ status: string; appointment_status_label?: string | null }>,
) {
  const buckets = {
    total: appointments.length,
    finished: 0,
    confirmed: 0,
    upcoming: 0,
    cancelled: 0,
    other: 0,
  }

  for (const appointment of appointments) {
    const { key } = resolveAppointmentStatusPresentation(
      appointment.status,
      appointment.appointment_status_label,
    )
    if (key === 'finished') buckets.finished += 1
    else if (key === 'confirmed') buckets.confirmed += 1
    else if (key === 'upcoming' || key === 'waiting' || key === 'in_progress') buckets.upcoming += 1
    else if (key === 'cancelled' || key === 'no_show') buckets.cancelled += 1
    else buckets.other += 1
  }

  return buckets
}

export function appointmentStatusBadgeClassName(tone: AppointmentStatusTone) {
  switch (tone) {
    case 'success':
      return 'bg-emerald-50 text-emerald-700 ring-emerald-100'
    case 'info':
      return 'bg-blue-50 text-blue-700 ring-blue-100'
    case 'warning':
      return 'bg-amber-50 text-amber-800 ring-amber-100'
    case 'danger':
      return 'bg-rose-50 text-rose-700 ring-rose-100'
    default:
      return 'bg-slate-100 text-slate-600 ring-slate-200'
  }
}
